import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {Component, Output, Input,OnInit, SimpleChanges, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, OnChanges} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-common-comments',
  templateUrl: './common-comments.component.html',
  styleUrls: ['./common-comments.component.scss'],
  imports: [CommonModule, ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
  })

export class CommonCommentsComponent implements OnInit,OnChanges {
  @Input() commentData: any = '';
  @Input() commentLabel: any = 'Comments';
  @Input() isReadOnly = false;
  @Input() textLength = 1500;
  @Output() commentUpdated = new EventEmitter<string>();
  placeholder = 'ABCD01234';
  public commentsFormData = new FormControl();

  onBlur() { 
    this.commentUpdated.emit(this.commentsFormData.value);
  }

  ngOnInit() {
    this.commentsFormData = new FormControl({value: this.commentData, disabled: this.isReadOnly});
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isReadOnly']) {
      if (this.isReadOnly) {
        this.commentsFormData.disable();
      } else {
        this.commentsFormData.enable();
      }
    }
    if (changes['commentData'] && changes['commentData'].currentValue !== changes['commentData'].previousValue) {
      this.commentsFormData.setValue(this.commentData); 
    }
  }
}
